const languages = {

    english:{
        search:'Search',
        placeholder:'What would you like to watch today'
    },
    hindi:{
        search:'खोज',
        placeholder:'आज आप क्या देखना चाहेंगे'
    },
    spanish:{
        search:'buscar',
        placeholder:'¿Qué te gustaría ver hoy?'
    },
    russian:{
        search:'поиск',
        placeholder:'Что бы вы хотели посмотреть сегодня'
    },
    italian:{
        search:'ricerca',
        placeholder:'Cosa ti piacerebbe guardare oggi?'
    },
    chinise:{
        search:'搜索',
        placeholder:'今天你想看什么'
    },
    tamil:{
        search:'தேடல்',
        placeholder:'இன்று நீங்கள் என்ன பார்க்க விரும்புகிறீர்கள்'
    },
    french:{
        search:'recherche',
        placeholder:"Qu'aimeriez-vous regarder aujourd'hu"
    },
    korean:{
        search:'찾다',
        placeholder:'오늘은 무엇을 보고 싶나요?'
    },
    portuguese:{
        search:'procurar',
        placeholder:'O que você gostaria de assistir hoje'
    },
}

export default languages;